import { SystemStyleObject } from '@chakra-ui/react';

const modalBodySx: SystemStyleObject = {
  pt: 2,
  pb: 4,
  wordBreak: 'break-all',
  minHeight: 150,
  transition: 'max-height 0.15s ease-in-out',
};

export { modalBodySx };
